import { render, staticRenderFns } from "./borderChart.vue?vue&type=template&id=2368de91&"
import script from "./borderChart.vue?vue&type=script&lang=js&"
export * from "./borderChart.vue?vue&type=script&lang=js&"
import style0 from "./borderChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports